import { IReservationsState } from './ReservationsInterfaces';

const RESERVATIONS_INITIAL_STATE: IReservationsState = {
  data: [],
  hasBilledReservations: false,
  isLoading: false,
};

export default RESERVATIONS_INITIAL_STATE;
